import { FaCheck } from 'react-icons/fa';

export const Stepper = ({
  steps,
  currentStep,
  onStepChange,
  allowClickNavigation = false,
  orientation = 'horizontal',
  variant = 'default',
  className = '',
}) => {

  const handleStepClick = (stepIndex) => {
    if (steps[stepIndex].isCompleted) return; 

    if (allowClickNavigation && onStepChange) {
      onStepChange(stepIndex); 
    }
  };
  
  const getStepStatus = (stepIndex) => {
    const step = steps[stepIndex];
    if (step.isCompleted) {
      return 'completed'; 
    }
    if (stepIndex === currentStep) {
      return 'current'; 
    }
    return 'upcoming';
  };

  const renderStep = (step, stepIndex) => {
    const status = getStepStatus(stepIndex);
    const isClickable = allowClickNavigation && status !== 'completed';

    const stepClasses = `
      flex items-center
      ${orientation === 'horizontal' ? 'flex-col' : 'flex-row'}
      ${isClickable ? 'cursor-pointer' : 'cursor-not-allowed'} // Disable cursor for completed steps
      ${orientation === 'horizontal' ? 'text-center' : 'text-left'}
    `;

    const circleClasses = `
      flex items-center justify-center
      ${variant === 'dots' ? 'w-3 h-3' : 'w-10 h-10'}
      rounded-full border-2 transition-all duration-200
      ${status === 'completed' ? 'bg-green-500 border-blue-600 text-white' : status === 'current' ? 'bg-[#2b364b] border-blue-600 text-white' : 'bg-gray-300 border-gray-300 text-gray-500'}
      ${isClickable ? 'hover:border-blue-400' : ''}
    `;

    const lineClasses = `
      ${orientation === 'horizontal' ? 'w-full h-0.5' : 'w-0.5 h-full'}
      ${status === 'completed' || stepIndex < currentStep ? 'bg-[#2b364b]' : 'bg-gray-300'}
    `;

    return (
    <div key={step.id} className={`flex items-center ${stepIndex < steps.length - 1 ? 'flex-1' : ''}`}>
        <div
          className={stepClasses}
          onClick={() => isClickable && handleStepClick(stepIndex)} 
        >
          <div className={circleClasses}>
            {variant === 'dots' ? null : status === 'completed' ? (
              <FaCheck className="w-5 h-5" />
            ) : (
              <span className="text-sm font-medium font-montserrat">{stepIndex + 1}</span>
            )}
          </div>

          {variant !== 'dots' && (
            <div className={`mt-2 ${orientation === 'vertical' ? 'ml-4 mt-0' : ''}`}>
              <div className="text-sm font-medium font-montserrat">{step.title}</div>
            </div>
          )}
        </div>

        {stepIndex < steps.length - 1 && (
          <div className={`${orientation === 'horizontal' ? 'flex-1 mx-4' : 'ml-5 my-4'}`}>
            <div className={lineClasses} />
          </div>
        )}
      </div>
    );
  };

  return (
    <div className={`w-full max-w-[672px] mx-auto ${className}`}>
      <div className={`flex ${orientation === 'horizontal' ? 'flex-row items-start' : 'flex-col'} ${orientation === 'horizontal' ? 'justify-between' : ''}`}>
        {steps.map((step, index) => renderStep(step, index))}
      </div>
    </div>
  );
};
